import type { FC } from 'react';
import parse from 'html-react-parser';

import { cn } from '@/lib/utils';

import { Card, type CardProps } from '@/components/atoms/Card';
import H4 from '@/components/atoms/Typography/H4';
import { IconPointerList } from '@/components/molecules/IconPointerList';
import type { ListItemType } from '@/components/molecules/IconPointerList/IconPointerList.types';

export interface InfoCardTemplateProps extends Omit<CardProps, 'children'> {
    heading: string;
    listData: ListItemType[];
}

const InfoCardTemplate: FC<InfoCardTemplateProps> = ({
    heading,
    listData,
    className,
    ...cardProps
}) => (
    <Card
        size="l"
        variant="shadow"
        className={cn(
            'mx-1 my-4 flex w-full max-w-[488px] flex-col justify-between gap-6 self-stretch lg:m-0 lg:gap-8',
            className,
        )}
        {...cardProps}
    >
        <H4 className={'self-stretch'}>{parse(heading)}</H4>

        <IconPointerList
            listData={listData}
            variant="separated"
        />
    </Card>
);

export default InfoCardTemplate;
